import { Box } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import React, { useEffect, useState } from 'react';
import { map } from 'rxjs';

import { GeneralConstants } from 'app/constants';
import { Brand } from 'app/model/cris/brand';
import { BrandAttributes } from 'app/model/cris/brand-attributes';
import { brandHistoryService } from 'app/services/brand/brand-history.service';
import { DataGridFormatters } from 'app/utils/data-grid-formatters';
import { HistoryReconstructor } from 'features/core/history-reconstructor';

interface HistoryProps {
    brand: Brand;
}

interface HistoryRecord {
    id: number;
    name: string;
    entityId: string;
    value: number;
    details?: string;
    eventDate: string;
}

export const BrandAttributeHistory: React.FC<HistoryProps> = ({ brand }) => {
    const [history, setHistory] = useState<HistoryRecord[]>([]);
    const [loading, setLoading] = useState(true);

    const columns = [
        { field: 'entityId', headerName: 'ID', width: 130 },
        { field: 'name', headerName: 'Name', width: 200 },
        { field: 'value', headerName: 'Value', width: 130 },
        { field: 'eventDate', headerName: 'Date', width: 200, valueFormatter: DataGridFormatters.dateTimeFormatter },
        { field: 'details', headerName: 'Details', width: 200 },
    ];

    useEffect(() => {
        const historyHelper = new HistoryReconstructor<BrandAttributes>();

        brandHistoryService
            .listAll({ pageSize: GeneralConstants.PAGE_SIZE_ENORMOUS }, brand)
            .pipe(
                map((data) => {
                    return data.map((historyData) => {
                        const instance = historyHelper.processRecord(historyData);

                        return {
                            ...instance.object,
                            ...instance,
                        };
                    });
                }),
            )
            .subscribe((data) => {
                setHistory(data);
                setLoading(false);
            });
    }, [brand]);

    return (
        <Box>
            <DataGridPro
                rows={history}
                columns={columns}
                paginationModel={{ pageSize: 25, page: 0 }}
                autoHeight
                density='compact'
                loading={loading}
                disableRowSelectionOnClick
            />
        </Box>
    );
};
